/** Client-side preview for {{merge_tags}} in email templates. */

const MERGE_TAG_PATTERN = /\{\{\s*(\w+)\s*\}\}/g;

const DEFAULTS = {
  first_name: 'Alex',
  last_name: 'Smith',
  email: 'alex@example.com',
  brand_name: 'Your Brand',
  brand: 'Your Brand',
  name: 'Alex',
  cta_url: 'https://yoursite.com',
  cart_url: 'https://yoursite.com/cart',
  product_name: 'Pro Plan',
  audience: 'creators like you',
  highlight_1: 'New dashboard widgets shipped this week.',
  highlight_2: 'Customer stories and tips from the community.',
};

export function buildSampleMergeContext({ website, fromName } = {}) {
  const brand = (fromName || website?.name || DEFAULTS.brand_name).trim();
  return {
    ...DEFAULTS,
    brand_name: brand,
    brand,
  };
}

export function renderMergeTemplate(template, context = DEFAULTS) {
  if (!template) return '';
  return template.replace(MERGE_TAG_PATTERN, (_match, key) => {
    const value = context[key];
    if (value === undefined || value === null || value === '') {
      return DEFAULTS[key] ?? '';
    }
    return String(value);
  });
}

export function hasMergeTags(text) {
  return /\{\{\s*\w+\s*\}\}/.test(text || '');
}

export const MERGE_TAG_HINT =
  'Use {{first_name}}, {{brand_name}}, {{cta_url}}, {{product_name}}, etc. Tags personalize per subscriber when you send.';
